import React, { useState, useEffect } from "react";
import ReactTooltip from "react-tooltip";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import Barcode from "react-barcode";
import Currency from "react-currency-formatter";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Media from "react-media";
import moment from "moment";
import { analytics, logEvent } from '~/services/firebaseConfig'
import Loading from "~/components/layout/Loading";
import { useHistory } from "react-router-dom";
import attention from '~/assets/images/warning-red.svg';

import {
  Container,
  Header,
  Left,
  Title,
  CloseIcon,
  Icon,
  Content,
  CardTitle,
  Info,
  InfoTitle,
  InfoText,
  Hr,
  DetailsContainer,
  DetailsContent,
  SectionTitle,
  StatusContainer,
  StatusIcon,
  TypeableLineContainer,
  TypeableLineText,
  TypeableLineIcon,
  ToolTipText,
  ToolTipButton,
  ToolTipButtonPixCode,
  BankSlipContainer,
  BarcodeContainer,
  BarcodeContent,
  DownloadContainer,
  DownloadButton,
  DownloadIcon,
  DetailsContentMiddle,
  LeftMiddle,
  Right,
  InfoLeft,
  InfoTextLeft,
  Box,
  PixQRCode,
} from "./styles";
import { Creators as InvoiceActions } from "~/store/ducks/invoice";
import api from "~/services/api";
import { handleStatus } from "~/utils/functions/bankSlips";

function Modal({ close, modalInformation, access_token, login_email }) {
  const [selectedTypeableLine, setSelectedTypeableLine] = useState("");
  const [fallbackImage, setFallbackImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [customer, setCustomer] = useState({});
  const [selectedPixCode, setSelectedPixCode] = useState("")
  const installment = modalInformation;
  const invoice = modalInformation.invoice;
  const status = handleStatus(modalInformation);
  const history = useHistory();

  useEffect(() => {
    getCustomerInfo(invoice.invoiceId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getCustomerInfo(invoiceId) {
    const header = {
      "Content-Type": "application/json",
      access_token: localStorage.getItem("access_token"),
    };
    const parameters = {
      method: "POST",
      headers: header,
    };
    api
      .get(
        `industrial/invoice/v1/invoices/${invoiceId}`,
        parameters
      )
      .then((res) => {
        if (res.data.customer) {
          setCustomer(res.data.customer);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  function handleCopyToClickBoard(selectedTypeableLine) {
    logEvent(analytics, 'copiando_linha_digitavel');
    return setSelectedTypeableLine(selectedTypeableLine);
  }

  function convertLine(typeableLine) {
    const line = `${typeableLine}`;
    const bank = line.substring(0, 3);
    const coin = line.substring(3, 4);
    const camp = line.substring(4, 9);
    const camp2 = line.substring(10, 20);
    const camp4 = line.substring(21, 31);
    const camp6 = line.substring(32, 47);
    const result = bank + coin + camp6 + camp + camp2 + camp4;
    return result;
  }

  function requestDownloadBoleto() {
    const header = {
      "Content-Type": "application/json",
      access_token: localStorage.getItem("access_token"),
    };
    const parameters = {
      method: "POST",
      responseType: "blob",
      headers: header,
    };
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      deliveryMethod: "DOWNLOAD",
      contactIdSf: localStorage.getItem("contactIdSf"),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}/installments/${installment.installmentId}/bankslips`,
        body,
        parameters
      )
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${installment.installmentId}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((err) => {
        const erro = err.response.data;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else {
          if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      });
  }

  function requestEmailBoleto() {
    const header = {
      "Content-Type": "application/json",
      access_token: localStorage.getItem("access_token"),
    };
    const parameters = {
      method: "POST",
      headers: header,
    };
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      deliveryMethod: "EMAIL",
      email: login_email,
      contactIdSf: localStorage.getItem("contactIdSf"),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}/installments/${installment.installmentId}/bankslips`,
        body,
        parameters
      )
      .then((res) => {
        if (res.status) {
          if (res.status === 204) {
            toast.success(`Boleto enviado para o e-mail: ${login_email}`);
          }
        }
      })
      .catch((err) => {});
  }

  function handleCopyToClickBoardPixKey(selectedPixCode) {
    logEvent(analytics, "copiando_linha_digitavel");
    return setSelectedPixCode(selectedPixCode);
  }

  let qrcodeData = null
  try {
    if ('qrcodeData' in installment) {
      qrcodeData = JSON.parse('{' + installment.qrcodeData + '}');
    }
  } catch (error) {

  }

  return (
    <Container className="background">
      <Box>
        <Header>
          <Left>
            <Icon className="mdi mdi-barcode mr-2" />
            <Title>Boletos</Title>
          </Left>
          <CloseIcon
            title="Fechar"
            className="mdi mdi-close"
            onClick={() => close()}
          />
        </Header>
        {loading ? (
          <Content>
            <Loading />
          </Content>
        ) : (
          <Content>
            <CardTitle>Detalhes da Cobrança</CardTitle>
            <Content>
              <Info className="mt-3">
                <InfoTitle>Cliente:</InfoTitle>
                <InfoText>{customer.name}</InfoText>
              </Info>
              <Info className="mt-2">
                <InfoTitle>Endereço:</InfoTitle>
                <InfoText>
                  {customer.address}, {customer.addressNumber} -{" "}
                  {customer.county}, {customer.city} - {customer.stateCode}
                </InfoText>
              </Info>
              <Hr />
              <DetailsContainer>
                <SectionTitle>Detalhes</SectionTitle>
                <DetailsContentMiddle>
                  <LeftMiddle>
                    <InfoLeft>
                      <InfoTitle>Número da Nota:</InfoTitle>
                      <InfoTextLeft
                        style={{ cursor: "pointer" }}
                        onClick={() => history.push(`/notas?invoice-number=${invoice.invoiceNumber}`)}
                      >
                        {invoice.invoiceNumber}
                      </InfoTextLeft>
                    </InfoLeft>
                    <StatusContainer>
                      <StatusIcon
                        color={
                          status === "Pago"
                            ? "#75B943"
                            : status === "Vencido"
                              ? "#e34e2a"
                              : status === "A Vencer"
                                ? "#f0b01b"
                                : "#000"
                        }
                      />
                      <InfoTitle>{status}</InfoTitle>
                    </StatusContainer>
                  </LeftMiddle>
                  <Right>
                    <Info>
                      <InfoTitle>Vencimento:</InfoTitle>
                      <InfoText>
                        {moment(installment.dueDate).format("DD/MM/YYYY")}
                      </InfoText>
                    </Info>
                    <Info style={{ marginLeft: 20 }}>
                      <InfoTitle>Valor:</InfoTitle>
                      <InfoText>
                        <Currency
                          quantity={installment.amountOriginal}
                          currency="BRL"
                          locale="pt"
                        />
                      </InfoText>
                    </Info>
                  </Right>
                </DetailsContentMiddle>
              </DetailsContainer>
              <Hr />
              {installment.qrcodeData && (
                <>
                  <SectionTitle>Pagamento via PIX</SectionTitle>
                  {qrcodeData?.dados_qrcode?.emv && (
                    <CopyToClipboard text={qrcodeData?.dados_qrcode?.emv}>
                      <ToolTipButtonPixCode
                        onClick={() => handleCopyToClickBoardPixKey(qrcodeData?.dados_qrcode?.emv)}
                        data-tip
                        data-for={installment.installmentId}
                      >
                        <TypeableLineText numberOfLines={1}>
                          Clique ao lado para copiar a chave pix.
                        </TypeableLineText>
                        <TypeableLineIcon className="mdi mdi-content-copy" />
                      </ToolTipButtonPixCode>
                    </CopyToClipboard>
                  )}
                  {selectedPixCode === qrcodeData?.dados_qrcode?.emv ? (
                    <ReactTooltip id={installment.installmentId} place="right" type="dark" effect="solid">
                      <ToolTipText>Copiado</ToolTipText>
                    </ReactTooltip>
                  ) : (
                    <ReactTooltip id={installment.installmentId} place="right" type="dark" effect="solid">
                      <ToolTipText>Clique para copiar</ToolTipText>
                    </ReactTooltip>
                  )}
                  <Info style={{ paddingTop: '1rem' }}>
                    <InfoTitle>QRCODE PIX</InfoTitle>
                  </Info>
                  <PixQRCode>
                    <img
                      src={fallbackImage || `data:image/png;base64,` + qrcodeData?.dados_qrcode?.base64}
                      width={`100%`}
                      height={`100%`}
                      alt="QR Code"
                      onError={(e) => {
                        setFallbackImage(attention);
                        toast.error("Ocorreu um erro ao processar os dados do QR Code. Por favor, entre em contato com o suporte.");
                      }}
                    />
                  </PixQRCode>
                  <Hr />
                </>
              )}
              {installment.paymentTypeBoleto && installment.typeableLine ? (
                <>
                  <BankSlipContainer>
                    <SectionTitle>Boleto de Cobrança</SectionTitle>
                    <DetailsContent>
                      <Info>
                        <InfoTitle>Linha Digitável:</InfoTitle>
                        <TypeableLineContainer>
                          <TypeableLineText numberOfLines={1}>
                            {installment.typeableLine}
                          </TypeableLineText>
                          <CopyToClipboard text={installment.typeableLine}>
                            <ToolTipButton
                              onClick={() =>
                                handleCopyToClickBoard(installment.typeableLine)
                              }
                              data-tip
                              data-for={installment.typeableLine}
                            >
                              <TypeableLineIcon className="mdi mdi-content-copy" />
                            </ToolTipButton>
                          </CopyToClipboard>
                          {selectedTypeableLine === installment.typeableLine ? (
                            <ReactTooltip
                              id={installment.typeableLine}
                              place="right"
                              effect="solid"
                            >
                              <ToolTipText>Copiado</ToolTipText>
                            </ReactTooltip>
                          ) : (
                            <ReactTooltip
                              id={installment.typeableLine}
                              place="right"
                              type="dark"
                              effect="solid"
                            >
                              <ToolTipText>Clique para copiar</ToolTipText>
                            </ReactTooltip>
                          )}
                        </TypeableLineContainer>
                      </Info>
                      <BarcodeContainer className="mt-2">
                        <Info>
                          <InfoTitle>Código de Barras:</InfoTitle>
                          <BarcodeContent>
                            <Media
                              query="(min-width: 500px)"
                              render={() => (
                                <Barcode
                                  format={"ITF"}
                                  displayValue={false}
                                  width={1}
                                  height={50}
                                  background="#ffffff"
                                  value={convertLine(installment.typeableLine)}
                                />
                              )}
                            />
                            <Media
                              query="(max-width: 499px)"
                              render={() => (
                                <Barcode
                                  format={"ITF"}
                                  displayValue={false}
                                  width={0.6}
                                  height={50}
                                  background="#ffffff"
                                  value={convertLine(installment.typeableLine)}
                                />
                              )}
                            />
                          </BarcodeContent>
                        </Info>
                        <Info>
                          <InfoTitle>2ª via de boleto:</InfoTitle>
                          <DownloadContainer>
                            <DownloadButton
                              onClick={() => requestDownloadBoleto()}
                            >
                              <DownloadIcon className="mdi mdi-download mr-2" />
                            </DownloadButton>
                            <DownloadButton
                              onClick={() => requestEmailBoleto()}
                            >
                              <DownloadIcon className="mdi mdi-email" />
                            </DownloadButton>
                          </DownloadContainer>
                        </Info>
                      </BarcodeContainer>
                    </DetailsContent>
                  </BankSlipContainer>
                </>
              ) : null}
            </Content>
          </Content>
        )}
      </Box>
    </Container>
  );
}

const mapStateToProps = (state) => ({
  modalInformation: state.invoiceReducer.modalInformation,
  access_token: state.loginReducer.access_token,
  login_email: state.loginReducer.login_email,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(InvoiceActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
